<template>
    <div>

        <div class="logo-a-1">
          
            <span
                :style="{ fontSize: '40px', cursor: canGoPrevious ? 'pointer' : 'default', color: canGoPrevious ? (isPrevHovered ? '#000000' : '#B3B3B3') : '#B3B3B3' }"
                @click="goToPreviousPage" @mouseenter="isPrevHovered = true" @mouseleave="isPrevHovered = false">
                ←
            </span>
            <div style="font-size: 40px; color: #b3b3b3;">|</div> <!-- 中间的竖线 -->
            <span
                :style="{ fontSize: '40px', cursor: canGoNext ? 'pointer' : 'default', color: canGoNext ? (isNextHovered ? '#000000' : '#B3B3B3') : '#B3B3B3' }"
                @click="goToNextPage" @mouseenter="isNextHovered = true" @mouseleave="isNextHovered = false">
                →
            </span>
        </div>


    </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();

// 鼠标悬停状态
const isPrevHovered = ref(false);
const isNextHovered = ref(false);

// 定义每个tab下的子选项
const tabOptions = [
    // Past year papers (index 0)
    [
        'All', '2025', '2024', '2023', '2022', '2021', 
        '2020', '2019', '2018', '2017', '2016'
    ],
    // Difficulty (index 1)
    [
        'All', 'high difficulty', 'medium difficulty', 'least difficulty'
    ],
    // Knowledge points (index 2)
    [
        'All', 'knowledge3', 'knowledge2', 'Knowledge1'
    ],
    // Video & Notes (index 3) - 没有子选项
    []
];

// 计算当前页面索引和当前tab
const currentPageIndex = computed(() => {
    const currentPath = route.path;
    // 获取当前激活的tab
    const activeTab = parseInt(route.query.tab) || 0;
    // 获取当前选中的子选项索引
    const currentOption = route.query.option || 'All';
    let optionIndex = -1;
    
    if (tabOptions[activeTab]) {
        optionIndex = tabOptions[activeTab].indexOf(currentOption);
        // 如果没有找到当前选项，默认为第一个（All）
        if (optionIndex === -1) {
            optionIndex = 0;
        }
    }
    
    return {
        path: currentPath,
        activeTab,
        optionIndex,
        option: currentOption
    };
});

// 计算是否可以前往上一个选项
const canGoPrevious = computed(() => {
    const { activeTab, optionIndex } = currentPageIndex.value;
    // 如果当前tab没有子选项，则不能前进
    if (!tabOptions[activeTab] || tabOptions[activeTab].length === 0) {
        return false;
    }
    return optionIndex > 0;
});

// 计算是否可以前往下一个选项
const canGoNext = computed(() => {
    const { activeTab, optionIndex } = currentPageIndex.value;
    // 如果当前tab没有子选项，则不能前进
    if (!tabOptions[activeTab] || tabOptions[activeTab].length === 0) {
        return false;
    }
    return optionIndex < (tabOptions[activeTab].length - 1);
});

// 跳转到下一个选项
const goToNextPage = () => {
    const { activeTab, optionIndex } = currentPageIndex.value;
    // 确保当前tab有子选项
    if (!tabOptions[activeTab] || tabOptions[activeTab].length === 0) {
        return;
    }
    
    const nextIndex = optionIndex + 1;
    
    if (nextIndex < tabOptions[activeTab].length) {
        const nextOption = tabOptions[activeTab][nextIndex];
        router.push({
            path: route.path,
            query: {
                ...route.query,
                option: nextOption
            }
        });
    }
};

// 跳转到上一个选项
const goToPreviousPage = () => {
    const { activeTab, optionIndex } = currentPageIndex.value;
    // 确保当前tab有子选项
    if (!tabOptions[activeTab] || tabOptions[activeTab].length === 0) {
        return;
    }
    
    const prevIndex = optionIndex - 1;
    
    if (prevIndex >= 0) {
        const prevOption = tabOptions[activeTab][prevIndex];
        router.push({
            path: route.path,
            query: {
                ...route.query,
                option: prevOption
            }
        });
    }
};
</script>

<style lang="scss">
.logo-a {

    width: 1200px;
    height: 40px;

    margin-bottom: 68px;
    display: flex;
    position: relative;

//     .logo-a-1 {
//         width: 185px;
//         height: 40px;

//         position: absolute;
//         right: 0;
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         padding: 0 10px;
// border: 1px solid yellow;

//     }

}
</style>